// extracted by mini-css-extract-plugin
module.exports = {"TimeTick":"style_TimeTick__2j3cV"};